import styled from 'styled-components';

export const LinkMenuButtonDiv = styled.div`
    height: 20px !important;
    line-height: 20px !important;
    padding: 4px !important;
`;

export const LinkMenuButtonIconDiv = styled.div`
    margin-top: 5px;
`;

export const MenuButtonIconTooltipText = styled.span`
    font-weight: bold;
`;

export const LinkModalDiv = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.white};
    box-shadow: 0 0 4px 0 rgba(28, 28, 28, 0.2);
    box-sizing: border-box;
    height: 204px;
    left: -151px;
    margin-left: 400px;
    padding: 20px;
    position: absolute;
    top: 35px;
    width: 244px;
`;

export const LinkButtonsDiv = styled.div`
    margin-top: 14px;
    display: flex;
`;

export const LinkModalLabel = styled.label`
    color: ${({ theme }) => theme.colors.neutral900};
    display: flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 12px;
    margin-bottom: 12px;
`;

export const ListButtonDiv = styled.div`
    width: 35px;
    height: 28px;
    border-left: 1px solid #cccc;
    cursor: pointer;
    line-height: 1;
`;

export const ToolbarIcon = styled.img`
    width: 16px;
    margin-top: 8px;
`;

export const DropDown = styled.div`
    background: rgb(255, 255, 255);
    border-radius: 0px;
    border: 1px solid rgb(204, 204, 204);
    box-shadow: 0px 0px 4px 0px rgba(28, 28, 28, 0.2);
    height: 76px;
    width: 122px;
    margin-top: 12px;
    line-height: 0;
`;

export const DropDownOption = styled.div`
    cursor: pointer;
    text-align: left;
    letter-spacing: 0px;
    height: 24px;
    display: flex;
    padding: 7px;
    &:hover {
        background-color: #deebff;
    }
`;

export const ClearFormattingButtonDiv = styled.div`
    width: 35px;
    height: 28px;
    cursor: pointer;
    line-height: 1;
`;

export const BulletedList = styled.p`
    margin-top: 10px;
    font-size: 13px;
`;

export const NumberedList = styled.p`
    margin-top: 12px;
`;

export const ListImage = styled.img`
    height: 20px;
    margin-right: 7px;
`;

interface ITDProps {
    paddingTop: number;
    paddingBottom: number;
    paddingRight: number;
    paddingLeft: number;
    align: string;
}

export const OuterTD = styled.td<ITDProps>(({ paddingBottom, paddingTop, paddingLeft, paddingRight }) => ({
    paddingBottom,
    paddingTop,
    paddingLeft,
    paddingRight,
    wordBreak: 'break-word',
    fontSize: 14,
}));

export const InnerTable = styled.table({
    borderCollapse: 'separate',
    width: '100%',
    lineHeight: '100%',
    userSelect: 'text',
});
